import cookie from './cookie';

const debugCookieKey = '_debug_subsystem';
const subsystems = window.__SUBSYSTEMS__;
const subsystemPrefixMap = {};
subsystems.forEach((item) => {
  subsystemPrefixMap[item.apiPrefix] = item;
});

export default {
  get() {
    return subsystems;
  },
  getDebugSubsystem() {
    const debugCookie = cookie.get(debugCookieKey);
    if (!debugCookie) {
      return [];
    }
    return Array.from(new Set(debugCookie.split('|')));
  },
  getDebugSubsystemNames() {
    return this.getDebugSubsystem()
      .map((prefix) => subsystemPrefixMap[prefix].name)
      .join(' | ');
  },
  setDebugSystem(sub) {
    // sub=[''] 时，join 不出 |
    cookie.set(debugCookieKey, sub.length === 1 && sub.indexOf('') > -1 ? '|' : sub.join('|'));
  },
};
